function initProductCards() {
  // Color swatches functionality using event delegation
  const allCards = document.querySelectorAll(".card-product");

  allCards.forEach((product) => {
    handleRestNumber(product);

    product.addEventListener("click", (e) => {
      // Handle color swatches
      const colorOption = e.target.closest(".card-product__color-option");

      // Color Swatches Function
      if (colorOption) {
        e.preventDefault();
        handleColorSwatch(colorOption, product);
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initProductCards();
  window.initProductCards = initProductCards;
});

// Handle color swatch selection
function handleColorSwatch(colorOption, productCard) {
  // Check if already active
  if (colorOption.getAttribute("aria-current") === "true") return;

  const featuredImage = productCard.querySelector(
    ".card-product__image-container .card-product__image"
  );

  // Update active state
  colorOption
    .closest(".card-product__colors")
    .querySelectorAll(".card-product__color-option")
    .forEach((btn) => btn.setAttribute("aria-current", "false"));
  colorOption.setAttribute("aria-current", "true");

  // Update images
  const newImageSrc = colorOption.dataset.imageSrc;
  const newAltText = colorOption.dataset.imageAlt;

  if (featuredImage && newImageSrc) {
    featuredImage.src = newImageSrc;
    featuredImage.alt = newAltText;
  }

  // Update prices
  const variantPrice = colorOption.dataset.variantPrice;
  const variantComparePrice = colorOption.dataset.variantComparePrice;

  if (variantPrice) {
    const currentPriceEl = productCard.querySelector(
      ".card-product__current-price"
    );
    const comparePriceEl = productCard.querySelector(
      ".card-product__compare-price"
    );
    const savingsEl = productCard.querySelector(".savings .save-discount");
    const savingsContainer = productCard.querySelector(".savings");

    if (currentPriceEl) {
      // Format price using Shopify's formatMoney if available
      const price = parseInt(variantPrice);
      const formattedPrice = window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(
            price,
            window.money_without_trailing_zeros_format || window.money_format
          )
        : new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(price / 100);
      currentPriceEl.textContent = formattedPrice;

      // Update compare price and savings
      const comparePrice = parseInt(variantComparePrice) || 0;
      if (comparePrice > price) {
        // Show compare price
        if (comparePriceEl) {
          const formattedComparePrice = window.Shopify?.formatMoney
            ? window.Shopify.formatMoney(
                comparePrice,
                window.money_without_trailing_zeros_format ||
                  window.money_format
              )
            : new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(comparePrice / 100);
          comparePriceEl.textContent = formattedComparePrice;
          comparePriceEl.style.display = "inline";
        }
        currentPriceEl.classList.add("discounted");

        // Calculate and show savings percentage
        const saveValue = Math.ceil(100 - (price / comparePrice) * 100);
        if (savingsEl) {
          savingsEl.textContent = `-${saveValue}%`;
        }
        if (savingsContainer) {
          savingsContainer.style.display = "inline";
        }
      } else {
        // Hide compare price and savings
        if (comparePriceEl) {
          comparePriceEl.style.display = "none";
        }
        currentPriceEl.classList.remove("discounted");
        if (savingsContainer) {
          savingsContainer.style.display = "none";
        }
      }
    }
  }
}

function handleRestNumber(product) {
  // COUNTER OF REST SWATCHES
  const colorsHolder = product.querySelector(".card-product__colors");
  const colorOptions = product.querySelectorAll(".card-product__color-option");
  if (colorsHolder && colorOptions.length > 4) {
    const restCounter = colorsHolder.querySelector(".rest-counter");
    const restNumber = colorOptions.length - 4;
    restCounter.style.display = "inline";
    restCounter.textContent = `+${restNumber} Colour`;
  }
}
